import { useEffect, useId, useRef, useState } from "react";

// Grelha postural de referência (traço fino azulado + halo escuro discreto), partilhada por todas as fotografias.
export function PosturalGridSvg({ size, opacity, testId }) {
  const uid = useId().replace(/:/g, "");
  return (
    <svg data-testid={testId} className="absolute inset-0 w-full h-full pointer-events-none" style={{ opacity: Math.max(0, Math.min(1, opacity)), zIndex: 1 }} aria-hidden="true">
      <defs>
        <pattern id={`pg-${uid}`} width={size} height={size} patternUnits="userSpaceOnUse">
          <path d={`M ${size} 0 L 0 0 0 ${size}`} fill="none" stroke="#020617" strokeWidth="2.4" strokeOpacity="0.8" />
          <path d={`M ${size} 0 L 0 0 0 ${size}`} fill="none" stroke="#7dd3fc" strokeWidth="0.9" strokeOpacity="0.95" />
        </pattern>
        <pattern id={`pgm-${uid}`} width={size * 4} height={size * 4} patternUnits="userSpaceOnUse">
          <rect width={size * 4} height={size * 4} fill={`url(#pg-${uid})`} />
          <path d={`M ${size * 4} 0 L 0 0 0 ${size * 4}`} fill="none" stroke="#020617" strokeWidth="3.2" strokeOpacity="0.85" />
          <path d={`M ${size * 4} 0 L 0 0 0 ${size * 4}`} fill="none" stroke="#7dd3fc" strokeWidth="1.2" strokeOpacity="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#pgm-${uid})`} />
      <line x1="50%" y1="0" x2="50%" y2="100%" stroke="#020617" strokeWidth="2.4" strokeOpacity="0.85" strokeDasharray="3 5" />
      <line x1="50%" y1="0" x2="50%" y2="100%" stroke="#7dd3fc" strokeWidth="0.8" strokeOpacity="0.95" strokeDasharray="3 5" />
      <line x1="0" y1="50%" x2="100%" y2="50%" stroke="#020617" strokeWidth="2.4" strokeOpacity="0.85" strokeDasharray="3 5" />
      <line x1="0" y1="50%" x2="100%" y2="50%" stroke="#7dd3fc" strokeWidth="0.8" strokeOpacity="0.95" strokeDasharray="3 5" />
    </svg>
  );
}

// Versão autodimensionada: número fixo de colunas, para o mesmo aspeto em qualquer tamanho de fotografia.
export const PORTAL_GRID_COLUMNS = 12;
export function PosturalGridOverlay({ opacity, columns = PORTAL_GRID_COLUMNS, testId }) {
  const ref = useRef(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  return <div ref={ref} className="pointer-events-none absolute inset-0">{w > 0 && <PosturalGridSvg size={w / columns} opacity={opacity} testId={testId} />}</div>;
}
